import React from 'react';
import { AlignedInfo } from '@common/components';
import { Typography } from 'antd';
import { WorkforceGroupByIdQueryCgResponse } from '@common/graphql/schema';
import { convertToType } from '@scheduling/services';

const { Text } = Typography;

type Props = {
  data: WorkforceGroupByIdQueryCgResponse;
};

function humanizeHour(hours: number) {
  return `${hours} hours`;
}

export function AdminWorkforceGroupDetails({ data }: Props) {
  const { workforceGroup } = data;

  const renderFieldLabel = (label: string) => (
    <div style={{ width: 200 }}>{label}</div>
  );

  const renderDistributionValue = (
    enabled: boolean,
    value: string,
    valueType: 'days' | 'hours'
  ) => (
    <Text>
      {enabled ? 'Yes' : 'No'}{' '}
      {enabled
        ? `- ${convertToType(value, 'hours', valueType)} ${valueType}`
        : ''}
    </Text>
  );

  const weeklyUtilizationRules = [
    [
      renderFieldLabel('Minimum'),
      humanizeHour(workforceGroup.weeklyMinimumHours),
    ],
    [
      renderFieldLabel('Maximum'),
      humanizeHour(workforceGroup.weeklyMaximumHours),
    ],
  ];

  const shiftDistributionRules = [
    [
      renderFieldLabel('Advance shift visibility'),
      renderDistributionValue(
        workforceGroup.defaultConfig?.gateEarliestAdvanceTime || false,
        String(workforceGroup.defaultConfig?.earliestAdvanceTime),
        workforceGroup.defaultConfig?.earliestAdvanceTimeFormat as
          | 'days'
          | 'hours'
      ),
    ],
    [
      renderFieldLabel('Schedule release delay'),
      renderDistributionValue(
        workforceGroup.defaultConfig?.gateOpenShiftsVisibility || false,
        String(workforceGroup.defaultConfig?.openShiftsVisibilityDelayHours),
        workforceGroup.defaultConfig?.openShiftsVisibilityDelayHoursFormat as
          | 'days'
          | 'hours'
      ),
    ],
  ];

  return (
    <>
      <div className="admin-workforce-group-details">
        <Text strong className="admin-workforce-group-details__title">
          Weekly Utilization Rules
        </Text>
        <div style={{ height: 16 }} />
        <AlignedInfo content={weeklyUtilizationRules} />
        <div style={{ height: 12 }} />
        <Text strong className="admin-workforce-group-details__title">
          Shift Distribution
        </Text>
        <div style={{ height: 16 }} />
        <AlignedInfo content={shiftDistributionRules} />
      </div>
      <style jsx>{`
        .admin-workforce-group-details {
          margin-top: 16px;
        }
        :global(.admin-workforce-group-details__title) {
          font-size: 16px;
        }
      `}</style>
    </>
  );
}
